export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/years.800c7078.svg","height":165,"width":166,"blurWidth":0,"blurHeight":0};